import * as React from 'react'

import TransactionStatusLabel from './TransactionStatusLabel'
import { Summary } from './PayrollProgressBar'
import { Payroll } from '../../types'
import { currencyFormat } from '../../utils'

interface Props {
  payrollStatus: Payroll['status']
  summary: Summary
}

export default function AmountsSummaryWidget(props: Props) {
  const { summary, payrollStatus } = props
  return (
    <table className="w-full">
      <tbody>
        <tr>
          <th className="pb-2 text-left text-sm font-semibold uppercase leading-6 text-slate-400">
            All
          </th>
          <td className="pb-2 text-right text-sm text-slate-500">
            {currencyFormat(summary.amounts.total)}
          </td>
        </tr>
        <tr>
          <th className="text-left">
            {payrollStatus === 'Draft' ? (
              <TransactionStatusLabel status="Approved" />
            ) : (
              <TransactionStatusLabel status="Completed" />
            )}
          </th>
          <td className="text-right text-sm font-semibold text-slate-600">
            {currencyFormat(summary.amounts.Approved)}
          </td>
        </tr>
      </tbody>
    </table>
  )
}
